module.exports = __webpack_public_path__ + "media/images/doctor_degree-58d03bc0ba4fef0205d68f5f744e9bd3.png";